import { Validator } from '@vista-digital/validator';
import { defaultPasswordFieldDisplayText, passwordFieldDisplayTextValidator } from '../../../../subcomponents/form/field/password/types/display-text';
import { InvalidFieldNameError } from '../../../../types/invalid-field-name-error';
import { MemberPasswordResetFormFieldName } from './name';
const defaultMemberPasswordResetFormPasswordFieldProps = {
    name: MemberPasswordResetFormFieldName.Password,
    displayText: defaultPasswordFieldDisplayText
};
const memberPasswordResetFormPasswordFieldPropsValidator = Validator.object({
    name: Validator.isEqualTo(MemberPasswordResetFormFieldName.Password),
    displayText: passwordFieldDisplayTextValidator
});
/**
 * Default props provider for the Member Password Reset Form Field component.
 */
export const defaultMemberPasswordResetFormFieldPropsProvider = props => {
    switch (props.name) {
        case MemberPasswordResetFormFieldName.Password:
            return defaultMemberPasswordResetFormPasswordFieldProps;
        default:
            throw new InvalidFieldNameError('MemberPasswordResetFormField', props.name);
    }
};
export const memberPasswordResetFormFieldPropsValidator = Validator.any([
    memberPasswordResetFormPasswordFieldPropsValidator
]);
